import { membersApi } from "@services/apiMembersClient";
import {
  CreateContentInput,
  CreateContentOutput,
  DeleteContentByIdInput,
  DeleteContentByIdOutput,
  GetContentByIdInput,
  GetContentByIdOutput,
  GetContentOutput,
  GetLessonsContentOutput,
  RemoveContentsInput,
  UpdateContentByIdInput,
  UpdateContentByIdOutput,
  UpdateContentsVisibilityInput,
  UpdateReorderContentsInput,
  UpdateTransferContentsInput,
} from "@_types/contents";
import { CreateSignedUrlInput, CreateSignedUrlOutput, ResponsePaginationType } from "@_types/shared";
import { AxiosPromise } from "axios";

interface TemporaryDataType<T> {
  data: T;
}
export const createContent = (payload: CreateContentInput): AxiosPromise<CreateContentOutput> => {
  return membersApi.post(`/contents`, payload);
};

export const getContents = ({
  moduleUuid,
  studentUuid,
}: {
  moduleUuid: string;
  studentUuid?: string;
}): AxiosPromise<ResponsePaginationType<GetContentOutput>> => {
  return membersApi.get(`/contents`, {
    params: {
      moduleUuid,
      studentUuid,
      page: 1,
      pageSize: 99,
    },
  });
};

export const getContentById = ({ uuid }: GetContentByIdInput): AxiosPromise<GetContentByIdOutput> => {
  return membersApi.get(`/contents/${uuid}`);
};

export const getContentByStudentId = ({
  uuid,
  studentUuid,
}: GetContentByIdInput & { studentUuid: string }): AxiosPromise<GetLessonsContentOutput> => {
  return membersApi.get(`/contents/${uuid}`, {
    params: {
      studentUuid,
    },
  });
};

export const updateContentById = ({
  uuid,
  ...params
}: UpdateContentByIdInput): AxiosPromise<UpdateContentByIdOutput> => {
  return membersApi.patch(`/contents/${uuid}`, { ...params });
};

export const deleteContentById = ({ uuid }: DeleteContentByIdInput): AxiosPromise<DeleteContentByIdOutput> => {
  return membersApi.delete(`/contents/${uuid}`);
};

export const removeContents = (data: RemoveContentsInput): AxiosPromise<{ uuid: string }> => {
  return membersApi.delete<{ uuid: string }>(`/contents`, { data });
};

export const updateContentsVisibility = (data: UpdateContentsVisibilityInput): AxiosPromise<{ uuid: string }> => {
  return membersApi.patch<{ uuid: string }>(`/contents/visibility`, data);
};

export const updateTransferContents = (data: UpdateTransferContentsInput): AxiosPromise<{ uuid: string }> => {
  return membersApi.patch<{ uuid: string }>(`/contents/transfer`, data);
};

export const updateReorderContents = (data: UpdateReorderContentsInput): AxiosPromise<{ uuid: string }> => {
  return membersApi.patch<{ uuid: string }>(`/contents/reorder`, data);
};

export const deleteUploadedVideo = (uuid: string): AxiosPromise<{ uuid: string }> => {
  return membersApi.delete(`/contents/${uuid}/upload-video`);
};

export const notifyUploadedVideoStatus = (uuids: string[]) => {
  return membersApi.patch<{ uuid: string }>(`/contents`, { uuids: uuids });
};

export const createContentThumbSignedUrl = (data: CreateSignedUrlInput): AxiosPromise<CreateSignedUrlOutput> => {
  return membersApi.post(`/contents/cover/upload`, data);
};
